import NavBreadcrum from "components/NavBreadcrum";
import MapHomeWaste from "./MapHomeWaste";
import TableRoutes from "./TableRoutes";
import TableAlerts from "./TableAlertsWaste";
import SumaryData from "./SumaryDataWaste";
import ContainersFraction from "./ContainersFraction";
import ContainersFilling from "./ContainersFilling";
import ContainersRange from "./ContainersRange";
import BarsRoutes from "./BarsRoutes";
import DoughtModels from "./DoughtModels";
import DoughtDownload from "./DoughtDownload";
import DoughtActiveAlerts from "./DoughtActiveAlerts";
import DoughtSolvedAlerts from "./DoughtSolvedAlerts";
import { useState } from "react";

const HomeWaste = () => {
    const [range, setRange] = useState({ min: 60, max: 100 });
    return (
        <>
            <NavBreadcrum navs={[{ name: "labels.home", url: "/", icon: "home" }]} bread={[]} />
            <div className="row p-2">
                <div className="w-50">
                    <div className="d-flex h-100 flex-column justify-content-between gap-2">
                        <SumaryData />
                        <MapHomeWaste range={range} />
                        <ContainersRange range={range} updateRange={setRange} />
                    </div>
                </div>
                <div className="w-50">
                    <div className="row g-2">
                        <div className="col-4"><ContainersFraction /></div>
                        <div className="col-4"><DoughtModels /></div>
                        <div className="col-4"><DoughtDownload /></div>
                        <div className="col-8"><ContainersFilling /></div>
                        <div className="col-4"><DoughtActiveAlerts /></div>
                        <div className="col-12"><DoughtSolvedAlerts /></div>
                    </div>
                </div>
                <div className="p-2">
                    <TableRoutes />
                </div>

            </div>
        </>
    );
};
export default HomeWaste;
